import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="m8.5 13.5 7-4-4 6.5 3 2.5c1 1 3 1.5 3.5-.5l2.181-11.068c.012-.061.03-.12.05-.18.369-1.113-.72-2.189-1.845-1.77L3.52 10.244c-1.194.443-1.234 2.093-.115 2.615a.756.756 0 0 0 .23.06l4.864.58Z"
    fill="none"
  />,
  'Telegram'
)
